var _path, _rect, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 302,
    viewBox: "0 0 293 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 267.855L165.649 112.659",
    stroke: "#171A1C",
    strokeWidth: 7.6129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.5342,
    width: 214,
    height: 94,
    rx: 4,
    transform: "rotate(16.3962 87.5342 0)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.424 70.7496L138.884 48.7952C139.399 47.0422 140.091 45.1594 140.958 43.1469L112.393 64.8556L132.424 70.7496ZM148.702 75.5393L147.179 80.7149C147.031 81.2157 146.736 81.5974 146.292 81.8599C145.876 82.1306 145.345 82.1708 144.698 81.9806L138.246 80.0821L133.776 95.2749L125.89 92.9545L130.36 77.7617L104.088 70.0312C103.441 69.8409 102.932 69.4946 102.561 68.9922C102.226 68.4703 102.07 67.9104 102.093 67.3125L102.516 62.4483L142.955 32.6232L151.473 35.1297L140.31 73.07L148.702 75.5393Z",
    fill: "#171A1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.851 82.0635C198.303 87.3225 196.388 91.7024 194.106 95.2032C191.851 98.7122 189.354 101.439 186.613 103.384C183.871 105.329 180.971 106.516 177.912 106.946C174.853 107.377 171.763 107.133 168.642 106.214C165.522 105.296 162.792 103.828 160.453 101.809C158.115 99.7908 156.32 97.2218 155.069 94.1024C153.846 90.9912 153.237 87.3502 153.242 83.1793C153.248 79.0085 154.024 74.2936 155.572 69.0345C157.119 63.7755 159.02 59.3914 161.274 55.8824C163.537 52.3455 166.021 49.6144 168.726 47.6892C171.467 45.7444 174.367 44.5569 177.426 44.1267C180.493 43.6687 183.587 43.8988 186.708 44.8171C189.829 45.7353 192.554 47.2176 194.885 49.2639C197.223 51.2823 199.018 53.8513 200.269 56.9708C201.529 60.0624 202.151 63.7076 202.138 67.9062C202.161 72.0853 201.398 76.8044 199.851 82.0635ZM190.489 79.3088C191.799 74.8567 192.522 71.0483 192.659 67.8837C192.833 64.6996 192.591 62.0433 191.934 59.9151C191.277 57.7868 190.286 56.1195 188.961 54.9132C187.636 53.707 186.144 52.8598 184.485 52.3717C182.798 51.8754 181.071 51.7754 179.304 52.0717C177.565 52.3763 175.843 53.2453 174.138 54.6787C172.433 56.1121 170.791 58.214 169.212 60.9846C167.642 63.7273 166.201 67.3247 164.891 71.7768C163.581 76.2289 162.84 80.047 162.666 83.2312C162.501 86.3875 162.747 89.0298 163.404 91.1581C164.061 93.2864 165.038 94.9495 166.335 96.1475C167.66 97.3538 169.166 98.2051 170.853 98.7014C172.512 99.1895 174.225 99.2854 175.992 98.9891C177.759 98.6927 179.495 97.8279 181.2 96.3945C182.905 94.9611 184.543 92.873 186.113 90.1303C187.72 87.368 189.179 83.7609 190.489 79.3088Z",
    fill: "#171A1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.273 99.5412L236.733 77.5868C237.249 75.8338 237.94 73.951 238.807 71.9386L210.242 93.6472L230.273 99.5412ZM246.551 104.331L245.028 109.506C244.881 110.007 244.585 110.389 244.141 110.651C243.726 110.922 243.195 110.962 242.548 110.772L236.096 108.874L231.625 124.066L223.739 121.746L228.21 106.553L201.937 98.8228C201.291 98.6325 200.782 98.2862 200.41 97.7838C200.075 97.2619 199.919 96.702 199.942 96.1042L200.365 91.2399L240.804 61.4148L249.323 63.9213L238.159 101.862L246.551 104.331Z",
    fill: "#171A1C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.0965,
    cy: 173.355,
    r: 22.8387,
    fill: "#171A1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9356 274.226C79.9356 283.686 71.4146 291.355 60.9034 291.355C50.3921 291.355 41.8711 283.686 41.8711 274.226C41.8711 264.766 50.3921 241.871 60.9034 241.871C71.4146 241.871 79.9356 264.766 79.9356 274.226Z",
    fill: "#171A1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67 274V298",
    stroke: "#171A1C",
    strokeWidth: 7.6129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5156 270.419L98.184 253.29",
    stroke: "#171A1C",
    strokeWidth: 7.6129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4199 274.419L30.4528 253.291",
    stroke: "#171A1C",
    strokeWidth: 7.6129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55 274V298",
    stroke: "#171A1C",
    strokeWidth: 7.6129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 183.83C118 217.661 91.5848 245.086 59 245.086C26.4152 245.086 0 217.661 0 183.83C0 161.261 12.007 110.483 27.5333 97.5865C37.3713 89.415 40.5231 93.712 43.9839 98.4303C47.0773 102.648 50.4175 107.202 59 103.489C66.5254 100.233 62.3525 86.594 58.533 74.1096C54.367 60.493 50.6214 48.2504 62.9333 52.3532C76.0472 56.7233 85.5354 66.6994 95.5922 90.3324C109.243 122.41 118 158.037 118 183.83ZM3.93284 174.289C3.93284 193.844 19.2854 209.689 38.3022 209.689C71.1837 209.689 114.066 174.289 114.066 174.289C114.066 174.289 71.1768 138.889 38.3021 138.889C19.2923 138.889 3.93284 154.734 3.93284 174.289ZM71 214C73.2091 214 75 212.209 75 210C75 207.791 73.2091 206 71 206C68.7909 206 67 207.791 67 210C67 212.209 68.7909 214 71 214Z",
    fill: "#171A1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.c6bf06dc7a0d7d0c017719bd2bc15f3e.svg";
export { ForwardRef as ReactComponent };